import { forwardRef } from "react";
import FixRequiredSelect from "./FixRequiredSelect";
import BaseSelect, {components, InputProps} from 'react-select';
import { Select } from "antd";

// const Input = (props) => {
//   return <components.Input {...props} required={ props.selectProps.required} >
//     {props.children}
//   </components.Input>
// };

// const Select = props => (
//   <FixRequiredSelect
//     {...props}
//     SelectComponent={BaseSelect}
//     components={{Input}}
//     options={props.options}
//   />
// );

const UBKSelect = forwardRef(({ ...rest }, ref) => (
  <div className="form-group">
    <label className="labelfont">{rest.label}</label>

   <Select dropdownStyle={{zIndex:"99999"}}  style={{width:"100%"}} className="input-cont" {...rest} ref={ref} /> 
  </div>
));

export default UBKSelect;


                     